import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "hooks/morning/axiosInstanse";

interface FaqRequest {
    category: string;
    limit: number;
    page: number;
    // search: "subject" | "contents";
    search: string;
    searchtxt: string;
}
export type DataListProps = {
    list_no: number;
    subject: string;
    counter: number;
    notice: number;
    w_date: string;
};

export interface FaqResponseData {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetFaq = ({ category, search, searchtxt, page, limit }: FaqRequest): UseQueryResult<FaqResponseData, Error> => {
    let url = enum_api_uri.get_faq.replace(":category", category);
    return useQuery({
        queryKey: ["useGetFaq", category, search, searchtxt, page, limit],
        queryFn: async () => {
            const response = await axiosInstance.get(url, {
                params: {
                    search,
                    searchtxt,
                    page,
                    limit,
                },
            });
            return response.data.data;
        },
    });
};
